import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfacfc72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Domain Settings", -1))
const _hoisted_3 = { class: "card col-md-6" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  for: "name",
  class: "form-label"
}
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "card-footer" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.loading ? "Loading" : "Url Prefix"), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "name",
            placeholder: "Url Prefix",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.prefix) = $event))
          }, null, 512), [
            [_vModelText, _ctx.prefix]
          ]),
          (_ctx.urlAlreadyInUse)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, " The domain prefix is already in use. Please choose another one. "))
            : _createCommentVNode("", true)
        ]),
        _createTextVNode(" Project pages are made available to your customers via this Url: "),
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("i", null, _toDisplayString(_ctx.workspaceDomain), 1),
        _createTextVNode(),
        _hoisted_10
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary ms-2 float-end",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
          disabled: !_ctx.prefix || !_ctx.prefix.length || _ctx.submitted
        }, _toDisplayString(_ctx.submitted ? "Storing" : "Update"), 9, _hoisted_12)
      ])
    ])
  ]))
}